import { render, staticRenderFns } from "./CoordinatorReview.vue?vue&type=template&id=41089c6a&scoped=true&"
import script from "./CoordinatorReview.vue?vue&type=script&lang=js&"
export * from "./CoordinatorReview.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorReview.vue?vue&type=style&index=0&id=41089c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41089c6a",
  null
  
)

export default component.exports